module.exports = {
  apiUrl: 'https://api.admin.uhc.ca',
  getAllCountries: "https://restcountries.eu/rest/v2/all?fields=name;languages;callingCodes",
}
